import type { RouteObject } from 'react-router-dom';
import type { TelemetryRouteHandle } from '@agnivo/app-core';

/**
 * web-ui-only account routes (ADR-182 W3). Data only (EAGER, costs nothing in the main bundle): the screen is a
 * dynamic `import()` so the page is its own lazy chunk and the `/agents` entry chunk does not grow. Paths are
 * ABSOLUTE and mount under the shared Layout root beside the section routes (same shape as
 * routes/admin-tenant/routes.ts). `handle.telemetryRoute: 'account'` is the architect-granted token (ruling
 * 2026-09-30; gateway allowlist gw!465 merged first), so a render failure on this page is attributable.
 */
export const accountRoutes: RouteObject[] = [
  {
    path: '/account',
    lazy: () => import('./AccountPage').then((m) => ({ Component: m.AccountRoute })),
    handle: { telemetryRoute: 'account' } satisfies TelemetryRouteHandle,
  },
];
